var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L5 7L12 10L19 7L12 4Z",
    stroke: "#222222",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66009 10.3159L4.80304 11.5404C4.6192 11.6192 4.5 11.7999 4.5 11.9999C4.5 12.2 4.6192 12.3807 4.80304 12.4595L11.803 15.4595C11.9288 15.5134 12.0712 15.5134 12.197 15.4595L19.197 12.4595C19.3808 12.3807 19.5 12.2 19.5 11.9999C19.5 11.7999 19.3808 11.6192 19.197 11.5404L16.3399 10.3159L15.0706 10.8599L17.7307 11.9999L12 14.456L6.2693 11.9999L8.92939 10.8599L7.66009 10.3159Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66009 15.3159L4.80304 16.5404C4.6192 16.6192 4.5 16.7999 4.5 16.9999C4.5 17.2 4.6192 17.3807 4.80304 17.4595L11.803 20.4595C11.9288 20.5134 12.0712 20.5134 12.197 20.4595L19.197 17.4595C19.3808 17.3807 19.5 17.2 19.5 16.9999C19.5 16.7999 19.3808 16.6192 19.197 16.5404L16.3399 15.3159L15.0706 15.8599L17.7307 16.9999L12 19.456L6.2693 16.9999L8.92939 15.8599L7.66009 15.3159Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.473bc21aa728ddaab67f39da21a0b0ad.svg";
export { ForwardRef as ReactComponent };